import posthog from 'posthog-js'
import { supabaseGestionPension as supabase } from '../config/settings/supabase-client'
import { REACT_APP_NOTIFIER_API_URL } from '../config/settings/environment'
import { getLogger } from '../core/debuggers'

const logger = getLogger('signupLifecycle.js')

const resolveBaseUrl = () => (REACT_APP_NOTIFIER_API_URL || '').replace(/\/$/, '')

/**
 * First-time profile insert: analytics + welcome email.
 * Must not throw — signup itself already succeeded.
 */
export async function onNewUserSignup() {
  posthog.capture('signup_completed')

  const baseUrl = resolveBaseUrl()
  if (!baseUrl) {
    logger.warn('REACT_APP_NOTIFIER_API_URL missing; welcome email skipped')
    return
  }

  try {
    const { data, error } = await supabase.auth.getSession()
    if (error) throw error
    const token = data?.session?.access_token
    if (!token) {
      logger.warn('No session token; welcome email skipped')
      return
    }

    const response = await fetch(`${baseUrl}/sender/welcome`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      logger.error('welcome email request failed', { status: response.status })
    }
  } catch (error) {
    logger.error('welcome email trigger failed', error)
  }
}
